"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
const react_1 = __importDefault(require("react"));
const Badge = ({ children, className }) => {
    return (react_1.default.createElement("span", { className: `rounded bg-yellow-3 px-2 py-1 text-xs font-semibold uppercase tracking-widest ${className}` }, children));
};
exports.Badge = Badge;
